import { render, staticRenderFns } from "./FuelBulkUpdateForm.vue?vue&type=template&id=bdc2fa06&"
import script from "./FuelBulkUpdateForm.vue?vue&type=script&lang=js&"
export * from "./FuelBulkUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports